import React from 'react';
import type { FC } from 'react';
import { TextInput } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';
import { useCreateAppBi } from '../bi/index.js';
import { validateAppNameSafe } from '../validations/index.js';

interface ChooseAppNameProps {
  onSubmit: (appName: string) => void;
}

export const ChooseAppName: FC<ChooseAppNameProps> = ({ onSubmit }) => {
  const { t } = useTranslation();
  const { cliFlowStepAnswered } = useCreateAppBi();

  return (
    <TextInput
      label={t('create_app.create_new.name_of_app.label')}
      placeholder={t('create_app.create_new.name_of_app.placeholder')}
      validate={validateAppNameSafe}
      onSubmit={(appName) => {
        cliFlowStepAnswered({
          question: t('create_app.create_new.name_of_app.label'),
          questionKey: 'create_app.create_new.name_of_app.label',
          answer: appName,
        });
        onSubmit(appName);
      }}
      inCreateFlow
    />
  );
};
